import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function ConfirmModal({ onConfirm }) {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button color="primary" onClick={toggle}>{t('Sign')}</Button>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("confirm_title")}</ModalHeader>
        <ModalBody>
          {t("confirm_message")}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            {t("Cancel")}
          </Button>{' '}
          <Button color="primary" onClick={() => {
            onConfirm()
            toggle()
          }}>
            {t("Confirm")}
          </Button>
        </ModalFooter>
      </Modal>
    </div >
  );
}

export default ConfirmModal;